import 'whatwg-fetch'
import 'promise-polyfill/src/polyfill';
import {notify} from "./tools/Notification";

/**
 * Component
 * @type {function(): {}}
 * @name formComponent
 */
export const formComponent = () => {

    let recaptchaStatus = false

    const ajaxformAction = async ( node ) => {

        node = node || null;

        const formClass = {
            ajaxPrefix: 'ajax-form-',
            fieldPrefix: 'ajax-field-',
            fieldErrorSelector: '#from-group-',
            fieldError: 'ajax-field-hold-error'
        };

        const bindForm = ( form ) => {

            if (form.appEventBinding) return;

            form.addEventListener('submit', (event) => {
                event.preventDefault();
                window.components.front.loader(true)

                handleLoading(form)

                let data = new FormData(form)
                let action = form.action

                /**
                 * Handle captcha
                 */
                handleCheck().then(token => {

                    data.append('recaptcha_token', token)

                    /**
                     * Execute request normally
                     */
                    window.fetch( action, {
                        method: 'POST',
                        headers: {
                            // 'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        body: data
                    })
                    .then(res => res.json())
                    .then(response => {

                        // phpdebugbar.ajaxHandler.handle(response);
                        window.components.front.loader(false)

                        if(response.status){
                            handleSuccess(response, form)
                        }else{
                            handleErrors(response.errors, form)
                        }

                    })
                    .catch(err => {
                        console.warn('Erreur : '+action)
                        console.warn(err)
                    })
                })

            })

            form.appEventBinding = true
            form.classList.add(formClass.ajaxPrefix+'binded')
        }

        const handleCheck = async () => {
            if (!recaptchaStatus) {
                await initRecaptcha()
            }
            return await checkCaptcha()
        }

        const handleLoading = ( form ) => {

            form.classList.add(formClass.ajaxPrefix+'loading')
            form.classList.remove(formClass.ajaxPrefix+'error')

            let nodes = form.querySelectorAll(formClass.fieldPrefix+'error' )
            nodes.forEach( ( node ) => {
                node.classList.remove(formClass.fieldPrefix+'error')
            })

            let errors = form.querySelectorAll('.'+formClass.fieldError )
            errors.forEach( ( node ) => {
                node.parentNode.removeChild(node)
            })
        }

        const handleSuccess = ( response, form ) => {

            form.classList.add(formClass.ajaxPrefix+'success')
            form.classList.remove(formClass.ajaxPrefix+'loading')

            notify( response.message ? response.message : form.dataset.success, {type:'success'})
            self.components.front.contactActions.close()
            setTimeout(function() {
                self.components.front.contactActions.initFormConditions()
                form.reset()
            },500)

            triggerGtmEvent('success', form)
        }

        const handleErrors = ( errors, form ) => {

            form.classList.add(formClass.ajaxPrefix+'error')
            form.classList.remove(formClass.ajaxPrefix+'loading')

            if(!errors) return

            let messages = []

            Object.keys(errors).forEach( ( id) => {

                let node = form.querySelector(formClass.fieldErrorSelector+id )
                if (node) {
                    node.classList.add(formClass.fieldPrefix+'error')

                    // create node error
                    let errornode = document.createElement('div')
                    errornode.classList.add(formClass.fieldError)
                    errornode.appendChild( document.createTextNode(errors[id]) )

                    // append error
                    node.appendChild(errornode)
                }

                // push message
                messages.push(errors[id])
            })

            // notify
            notify( messages, {type:'error'})

            triggerGtmEvent('error', form)
        }

        const triggerGtmEvent = ( type, form ) => {
            const formData = new FormData(form)
            let data = {}
            for(const pair of formData.entries()) {
                if (pair[1]) data[pair[0]] = pair[1]
            }
            if(dataLayer && typeof dataLayer === 'object') {
                dataLayer.push({'event': 'formSubmission', parameters: {type: type, data: data} });
            }
        }

        // bind form if node not null
        if( node ) bindForm( node );

        /**
         * Loop through forms at loading
         * @type {NodeListOf<Element>}
         */
        let forms = document.querySelectorAll('form.ajax-form')

        forms.forEach( ( form ) => {
            bindForm( form )
        })
    }

    const checkCaptcha = () => {
        return new Promise(function(resolve, reject){
            grecaptcha.ready(function() {
                grecaptcha
                    .execute(appjs.sitekey, {action: 'submit'})
                    .then( (token) => {
                        resolve(token)
                    })
            })
        })
    }

    const initRecaptcha = () => {
        return new Promise(function(resolve, reject) {
            let head = document.getElementsByTagName('head')[0]
            let script = document.createElement('script')
            script.type = 'text/javascript'
            script.addEventListener('load', function() {
                // this.removeEventListener('load', arguments.callee)
                recaptchaStatus = true
                resolve(script)
            })
            script.src = 'https://www.google.com/recaptcha/api.js?render='+appjs.sitekey
            head.appendChild(script)
        })
        // return new Promise(resolve => {
        //     let s = document.createElement('script');
        //     s.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render='+appjs.sitekey);
        //     document.body.appendChild(s);
        // })
    };

    /**
     * Execution permanente
     */
    ajaxformAction()

    return {
        initForm: ( node ) => {
            ajaxformAction( node )
        },
        bindForms: () => {
            ajaxformAction()
        }
    }
}

self.components = self.components || {};
self.components.form = formComponent();
